// extracted by mini-css-extract-plugin
export default {"root":"_1L06VhHcZj2cbUXOKpHHOA","popupError":"_3ZLpm5Ib-iPherXGpEKevO","logo":"_1Yf6GQaPYurZxcfyzC2utJ","logoPopup":"_2W9sg14p859MYeagq9Xkyp"};